// extracted by mini-css-extract-plugin
export var dark = "Dark-module--dark--c146a";